import React, { useState } from 'react';
import '../components/MockTest.css';
import Header from '../components/Header';
import MockTestList from '../components/MockTestList';
import MockTestRunner from '../components/MockTestRunner';
import mockTestData from '../data/mockTestData';
import { useAuth } from '../context/AuthContext';
import { getAccessibleMockTests, isPremiumUser, canAccessMockTest } from '../utils/subscriptionUtils';
import UpgradeModal from '../components/UpgradeModal';

const MockTest = () => {
  const { user } = useAuth();
  const [currentView, setCurrentView] = useState('list'); // 'list' or 'runner'
  const [selectedTestId, setSelectedTestId] = useState(null);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  const isPremium = isPremiumUser(user);
  const accessibleTests = getAccessibleMockTests(mockTestData, user);
  const selectedTest = mockTestData.find(test => test.id === selectedTestId);

  const handleSelectTest = (testId) => {
    // Check if user can access this test
    if (!canAccessMockTest(user, testId)) {
      setShowUpgradeModal(true);
      return;
    }
    
    setSelectedTestId(testId);
    setCurrentView('runner');
  };

  const handleBackToList = () => {
    setCurrentView('list');
    setSelectedTestId(null);
  };

  return (
    <div className="mock-test-page">
      <Header />
      
      {/* Subscription Banner for Free Users */}
      {!isPremium && (
        <div className="subscription-banner-mock">
          <div className="banner-content">
            <span className="banner-icon">🎯</span>
            <div className="banner-text">
              <strong>Free Account:</strong> You have access to {accessibleTests.length} of {mockTestData.length} mock tests. 
              <span className="banner-highlight"> Upgrade to Premium for unlimited access!</span>
            </div>
            <button className="banner-upgrade-btn" onClick={() => setShowUpgradeModal(true)}>
              Upgrade Now
            </button>
          </div>
        </div>
      )}
      
      <div className="mock-test-container">
        {currentView === 'list' ? (
          <MockTestList 
            tests={mockTestData}
            accessibleTests={accessibleTests}
            onSelectTest={handleSelectTest}
            isPremium={isPremium}
          />
        ) : (
          selectedTest && (
            <MockTestRunner 
              test={selectedTest}
              onBack={handleBackToList}
            />
          )
        )}
      </div>
      
      {/* Upgrade Modal */}
      <UpgradeModal 
        isOpen={showUpgradeModal}
        onClose={() => setShowUpgradeModal(false)}
        feature="mock tests"
        currentCount={accessibleTests.length}
        limitCount={3}
      />
    </div>
  );
};

export default MockTest;
